export default "__VITE_ASSET__CwwSgzrM__"